import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import axios from "axios";
import { saveAs } from "file-saver";
import moment from "moment";
import { formatLocalDateTime } from "../../utils/dateUtils";
import {
  useMediaQuery,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  Paper,
  IconButton,
  Container,
  TextField,
  CircularProgress,
  FormControl,
  makeStyles,
  useTheme,
  createTheme,
  ThemeProvider,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Grid,
} from "@material-ui/core";
import NonOrderPartiesTable from "./NonOrderPartiesTable";

import Alert from "@material-ui/lab/Alert";
import PropTypes from "prop-types";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import ClearIcon from "@material-ui/icons/Clear";
import { getAllClients } from "../../actions/clientActions";
import { getAllSuppliers } from "../../actions/supplierActions";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import RemoveRedEyeOutlinedIcon from "@material-ui/icons/RemoveRedEyeOutlined";
import Autocomplete from "@material-ui/lab/Autocomplete";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import { useLocation } from "react-router-dom";
import { useFilterContext } from "../../Context/FilterContext";
import ProgressButton from "react-progress-button";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {
  deleteInvoice,
  getInvoices,
  getInvoicesByPage,
  getInvoicesByUser,
  getInvoicesByClient,
  getInvoicesBySupplier,
  getInvoicesByDealer,
} from "../../actions/invoiceActions";
import { getUsers } from "../../actions/auth";
import NoData from "../svgIcons/NoData";
import Spinner from "../Spinner/Spinner";
import { useSnackbar } from "react-simple-snackbar";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import GetAppIcon from "@material-ui/icons/GetApp";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles((_theme) => ({
  table: {
    minWidth: 500,
  },

  tablecell: {
    fontSize: "16px",
  },
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "20px",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  typography: {
    fontSize: "18px",
    fontWeight: 500,
  },
}));

const tableStyle = {
  width: 160,
  fontSize: 14,
  cursor: "pointer",
  borderBottom: "none",
  padding: "8px",
  textAlign: "center",
};
const headerStyle = { borderBottom: "none", textAlign: "center" };
const colorTheme = createTheme({
  palette: {
    primary: {
      main: "#ef7f1a",
    },
  },
});

const Invoices = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [downloadStatus, setDownloadStatus] = useState(null);
  const user = JSON.parse(localStorage.getItem("profile"));
  const rows = useSelector((state) => state.invoices.invoices);
  //const [nonOrderParties, setNonOrderParties] = useState([]);

  const { numberOfPages, totalAmount, totalItems } = useSelector((state) => state.invoices);
  const { nonOrderParties, nonOrderPartiesCount } = useSelector(
    (state) => state.invoices
  );
  // //(invoices);
  // const [rows, setRows] = useState([]);
  const { users } = useSelector((state) => state.auth);
  const [showNonOrderParties, setShowNonOrderParties] = useState(false);
  const clients = useSelector((state) => state.clients.clients);
  const suppliers = useSelector((state) => state.suppliers.suppliers);
  // //(users);
  // //(rows);
  const [loading, setLoading] = useState(false);
  const isLoading = useSelector((state) => state.invoices.isLoading);

  // eslint-disable-next-line
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const {
    searchQuery,
    setSearchQuery,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    selectedFilter,
    setSelectedFilter,
    salesperson,
    setSalesperson,
    party,
    setParty,
    supplier,
    setSupplier,
  } = useFilterContext();
  const classes = useStyles2();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  // const rows = []

  // useEffect(() => {
  //   dispatch(getInvoices());

  //   // eslint-disable-next-line
  // }, [location, dispatch]);
  useEffect(() => {
    if (user?.result?.userType === "user") {
      // console.log(selectedFilter);

      if (selectedFilter === "customer" && searchQuery) {
        dispatch(
          getInvoicesByClient(
            page,
            rowsPerPage,
            searchQuery,
            startDate,
            endDate,
            user?.result?._id // Pass the current user's ID as creator
          )
        );
      } else {
        dispatch(
          getInvoicesByUser(
            page,
            rowsPerPage,
            user?.result?._id,
            startDate,
            endDate
          )
        );
      }
    } else if (user?.result?.userType === "dealer") {
      // For dealers, handle party and supplier filters
      if (selectedFilter === "customer" && searchQuery) {
        console.log('Dealer filtering by party:', searchQuery);
        dispatch(
          getInvoicesByDealer(
            page,
            rowsPerPage,
            user?.result?._id,
            startDate,
            endDate,
            searchQuery
          )
        );
      } else if (selectedFilter === "supplier" && searchQuery) {
        console.log('Dealer filtering by supplier:', searchQuery);
        dispatch(
          getInvoicesByDealer(
            page,
            rowsPerPage,
            user?.result?._id,
            startDate,
            endDate,
            null, // partyId - not filtering by party
            searchQuery // supplierId - filtering by supplier
          )
        );
      } else {
        console.log('Dealer showing all assigned clients');
        // For dealers, only show invoices for their assigned clients
        dispatch(
          getInvoicesByDealer(
            page,
            rowsPerPage,
            user?.result?._id,
            startDate,
            endDate
          )
        );
      }
    }
  }, [
    dispatch,
    page,
    rowsPerPage,
    selectedFilter,
    searchQuery,
    startDate,
    endDate,
  ]);
  useEffect(() => {
    if (user?.result?.userType === "admin") {
      if (selectedFilter === "salesperson" && searchQuery) {
        //  console.log("startDate",startDate);
        //  console.log("endDate",endDate);
        dispatch(
          getInvoicesByUser(page, rowsPerPage, searchQuery, startDate, endDate)
        );
      } else if (selectedFilter === "customer" && searchQuery) {
        dispatch(
          getInvoicesByClient(
            page,
            rowsPerPage,
            searchQuery,
            startDate,
            endDate
          )
        );
      } else if (selectedFilter === "supplier" && searchQuery) {
        dispatch(
          getInvoicesBySupplier(
            page,
            rowsPerPage,
            searchQuery,
            startDate,
            endDate
          )
        );
      } else {
        dispatch(
          getInvoicesByPage(
            page,
            rowsPerPage,
            startDate?.setHours(0, 0, 0),
            endDate
          )
        );
      }
    }
  }, [
    dispatch,
    page,
    rowsPerPage,
    selectedFilter,
    searchQuery,
    startDate,
    endDate,
  ]);
  useEffect(() => {
    dispatch(getUsers());
  }, [location]);

  // Note: Dealers can now use customer filter to search by party
  useEffect(() => {
    dispatch(
      // getClientsByUser({ search: user?.result._id || user?.result?.googleId })
      getAllClients()
    );
    dispatch(getAllSuppliers());
    // eslint-disable-next-line
  }, [dispatch]);
  const toCommas = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  // useEffect(() => {
  //   if (user?.result?.userType === "user") {
  //     const rows = invoices.filter(
  //       (inv) => inv.creator[0] === user?.result?._id
  //     );
  //     setRows( rows.filter(filterByDateRange));
  //   } else {
  //     setRows(invoices.filter(filterByDateRange));
  //   }
  // }, );
  const getCreatorDisplay = (creator) => {
    // creator may be a string id or an array (e.g. [id])
    const userId = Array.isArray(creator) ? creator[0] : creator;
    if (!userId) return "";
    const found = users.find((u) => u._id === userId);
    if (!found) return "";

    // Map userType to human label
    const roleLabel =
      found.userType === "admin"
        ? "Admin"
        : found.userType === "dealer"
        ? "Dealer"
        : "Salesperson";

    // For dealers prefer showing their client name (e.g. "aYuBox") if available
    let displayName = found.name || "";
    if (found.userType === "dealer") {
      if (found.selectedClients && found.selectedClients.length) {
        const sc = found.selectedClients[0];
        if (typeof sc === "string") {
          const clientObj = clients.find((c) => c._id === sc);
          if (clientObj && clientObj.name) displayName = clientObj.name;
        } else if (sc && sc.name) {
          displayName = sc.name;
        } else if (sc && sc._id) {
          const clientObj = clients.find((c) => c._id === sc._id);
          if (clientObj && clientObj.name) displayName = clientObj.name;
        }
      } else {
        // fallback: try to find a client that references this dealer
        const clientObj = clients.find((c) => {
          if (c.userId && Array.isArray(c.userId)) return c.userId.includes(userId);
          return false;
        });
        if (clientObj && clientObj.name) displayName = clientObj.name;
      }
    }

    return `${displayName} (${roleLabel})`;
  };

  const filterByDateRange = (invoice) => {
    if (!startDate || !endDate) return true;
    const invoiceDate = moment(invoice.createdAt);
    return invoiceDate.isBetween(startDate, endDate, "day", "[]");
  };
  const filteredRows = rows;
  // const filteredRows = rows.filter((row) => {
  //   return filterByDateRange(row);
  // });

  // useEffect(() => {
  // setRows(invoices)

  //   // eslint-disable-next-line
  // }, [invoices,page,rowsPerPage]);
  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleFilterChange = (event) => {
    setSelectedFilter(event.target.value); // Update the selected filter when the user changes the option
  };
  const editInvoice = (id) => {
    history.push(`/edit/invoice/${id}`);
  };
  const handleDelete = (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this client?"
    );
    if (confirmDelete) {
      dispatch(deleteInvoice(id, openSnackbar));
    }
  };

  const openInvoice = (id) => {
    history.push(`/invoice/${id}`);
  };
  const createAndDownloadPdf = () => {
    //(rows);
    //(filteredRows);
    setLoading(true);
    if (filteredRows.length) {
      setDownloadStatus("loading");
      axios
        .post(`${process.env.REACT_APP_API}/create-report`, {
          filteredRows,
          users,
        })
        .then(() =>
          axios.get(`${process.env.REACT_APP_API}/fetch-report`, {
            responseType: "blob",
          })
        )
        .then((res) => {
          const pdfBlob = new Blob([res.data], { type: "application/pdf" });
          // const downloadUrl = window.URL.createObjectURL(pdfBlob);
          // setDownloadStatus("success");
          // window.open(downloadUrl, "_blank");
          const currentDate = new Date();

          saveAs(pdfBlob, `OrderReport${currentDate}.pdf`);
          const downloadUrl = `${process.env.REACT_APP_URL}/files/Exported-Report/report.pdf`;
          window.open(downloadUrl, "_blank");
          setLoading(false);
          setDownloadStatus("success");
        });
    } else {
      openSnackbar("No record to Export");
    }
  };
  const handleClientNameClick = (id) => {
    history.push(`/stats/${id}`);
  };
  if (!user) {
    history.push("/login");
  }

  const handleStartDateChange = (date) => {
    // const formattedDate = date.toISOString().split("T")[0];
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    // const formattedDate = date.toISOString().split("T")[0];
    setEndDate(date);
  };
  const calTotalAmount = filteredRows.reduce((total, row) => {
    // Ensure that each row has an 'amount' property
    if (typeof row.total === "number") {
      return total + row.total;
    } else {
      return total;
    }
  }, 0);
  const salespersonsProps = {
    options: users,
    getOptionLabel: (option) => option.name,
  };
  // }
  // function checkStatus(status) {
  //   return status === "Partial"
  //     ? {
  //         border: "solid 0px #1976d2",
  //         backgroundColor: "#baddff",
  //         padding: "8px 18px",
  //         borderRadius: "20px",
  //       }
  //     : status === "Paid"
  //     ? {
  //         border: "solid 0px green",
  //         backgroundColor: "#a5ffcd",
  //         padding: "8px 18px",
  //         borderRadius: "20px",
  //       }
  //     : status === "Unpaid"
  //     ? {
  //         border: "solid 0px red",
  //         backgroundColor: "#ffaa91",
  //         padding: "8px 18px",
  //         borderRadius: "20px",
  //       }
  //     : "red";
  // }

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
        }}
      >
        <Spinner />
      </div>
    );
  }

  // Check if any filters are active
  const hasActiveFilters = startDate || endDate || searchQuery || selectedFilter;
  // Filter clients for dealers to only show their assigned clients
  const filteredClients = user?.result?.userType === "dealer" && user?.result?.selectedClients 
    ? clients.filter(client => user.result.selectedClients.some(assignedClient => {
        // Handle both cases: assignedClient as ObjectId string or as populated client object
        const assignedClientId = typeof assignedClient === 'string' ? assignedClient : assignedClient._id;
        return assignedClientId === client._id;
      }))
    : clients;

  // Debug logging
  if (user?.result?.userType === "dealer") {
    console.log('Dealer user:', user.result);
    console.log('Selected clients:', user.result.selectedClients);
    console.log('All clients:', clients);
    console.log('Filtered clients:', filteredClients);
  }

  const clientsProps = {
    options: filteredClients,
    getOptionLabel: (option) => option.name,
  };
  const suppliersProps = {
    options: suppliers,
    getOptionLabel: (option) => option.name,
  };
  return (
    <div
      style={{
        minHeight: isMobile ? "740px" : "470px",
      }}
    >
      <ThemeProvider theme={colorTheme}>
        <Container
          style={{
            width: isMobile ? "100%" : "85%",
            paddingTop: "2px",
            paddingBottom: "2px",
            border: "none",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
              }}
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  label="From"
                  name="FromDate"
                  value={startDate}
                  onChange={handleStartDateChange}
                  required
                  format="dd/MM/yyyy"
                  style={{ maxWidth: isMobile ? "50%" : "100%" }}
                />

                <KeyboardDatePicker
                  label="To"
                  name="EndDate"
                  value={endDate}
                  onChange={handleEndDateChange}
                  required
                  format="dd/MM/yyyy"
                  style={{ maxWidth: "50%" }}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
              }}
            >
              <FormControl style={{ width: "100px" }}>
                <InputLabel>Filter:</InputLabel>
                <Select
                  value={selectedFilter}
                  onChange={(event) => handleFilterChange(event)} // Provide the event object
                >
                  {user?.result?.userType === "admin" && (
                    <MenuItem value="salesperson">
                      Filter by SalesPerson
                    </MenuItem>
                  )}
                  {/* {user?.result?.userType === "dealer" && (
                    <MenuItem value="customer">Filter by Party</MenuItem>
                  )} */}
                  {user?.result?.userType !== "dealer" && (
                    <MenuItem value="customer">Filter by Party</MenuItem>
                  )}
                  {user?.result?.userType === "dealer" && (
                    <MenuItem value="supplier">Filter by Supplier</MenuItem>
                  )}

                </Select>
                {selectedFilter && (
                  <IconButton
                    size="small"
                    style={{
                      marginLeft: "8px",
                      backgroundColor: "transparent",

                      color: "#ef7f1a",
                      borderRadius: "4px",
                    }}
                    onClick={() => {
                      setSelectedFilter("");
                      setSearchQuery("");
                      setSalesperson("");
                      setParty("");
                      setShowNonOrderParties(false);
                    }}
                  >
                    <ClearIcon />
                  </IconButton>
                )}
              </FormControl>

              {selectedFilter && (
                <div>
                  {/* Display filtering results or perform filtering logic based on selectedFilter */}
                  {selectedFilter === "salesperson" ? (
                    <ThemeProvider theme={colorTheme}>
                      <Container>
                        {salesperson && (
                          <div
                            style={{
                              display: "flex",
                              marginTop: "20px",
                              gap: "5px",
                              height: "50px",
                            }}
                          >
                            <Typography variant="subtitle1" gutterBottom>
                              {salesperson.name}
                            </Typography>

                            <Button
                              color="primary"
                              size="small"
                              style={{
                                textTransform: "none",
                                backgroundColor: "#ef7f1a",
                                color: "white",
                              }}
                              onClick={() => {
                                setSalesperson(null);
                                setSearchQuery("");
                              }}
                            >
                              Change
                            </Button>
                          </div>
                        )}
                        <div
                          style={
                            salesperson
                              ? { display: "none" }
                              : { display: "block", width: "200px" }
                          }
                        >
                          <Autocomplete
                            {...salespersonsProps}
                            // PaperComponent={CustomPaper}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                // required={!invoice && true}
                                label="Select Sales Person"
                                margin="normal"
                                variant="outlined"

                                // error={touched && !!errors.client}
                                // helperText={touched && errors.client}
                              />
                            )}
                            value={salesperson}
                            onChange={(event, value) => {
                              setSalesperson(value);
                              setSearchQuery(value ? value._id : "");

                              // handleClientChange();
                            }}
                            // onChange={(event, value) => setClient(value) }
                          />
                        </div>
                      </Container>
                    </ThemeProvider>
                  ) : selectedFilter === "customer" ? (
                    <ThemeProvider theme={colorTheme}>
                      <Container>
                        {party && (
                          <div
                            style={{
                              display: "flex",
                              marginTop: "20px",
                              gap: "10px",
                              height: "50px",
                            }}
                          >
                            <Typography variant="subtitle1" gutterBottom>
                              {party.name}
                            </Typography>

                            <Button
                              color="primary"
                              size="small"
                              style={{
                                textTransform: "none",
                                backgroundColor: "#ef7f1a",
                                color: "white",
                              }}
                              onClick={() => {
                                setParty(null);
                                setSearchQuery("");
                              }}
                            >
                              Change
                            </Button>
                          </div>
                        )}
                        <div
                          style={
                            party
                              ? { display: "none" }
                              : { display: "block", width: "200px" }
                          }
                        >
                          <Autocomplete
                            {...clientsProps}
                            // PaperComponent={CustomPaper}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                // required={!invoice && true}
                                label="Select Party"
                                margin="normal"
                                variant="outlined"
                                // error={touched && !!errors.client}
                                // helperText={touched && errors.client}
                              />
                            )}
                            value={party}
                            onChange={(event, value) => {
                              console.log('Party selected:', value);
                              setParty(value);
                              setSearchQuery(value ? value._id : "");
                              console.log('Search query set to:', value ? value._id : "");

                              // handleClientChange();
                            }}
                            // onChange={(event, value) => setClient(value) }
                          />
                        </div>
                      </Container>
                    </ThemeProvider>
                  ) : selectedFilter === "supplier" ? (
                    <ThemeProvider theme={colorTheme}>
                      <Container>
                        {supplier && (
                          <div
                            style={{
                              display: "flex",
                              marginTop: "20px",
                              gap: "10px",
                              height: "50px",
                            }}
                          >
                            <Typography variant="subtitle1" gutterBottom>
                              {supplier.name}
                            </Typography>

                            <Button
                              color="primary"
                              size="small"
                              style={{
                                textTransform: "none",
                                backgroundColor: "#ef7f1a",
                                color: "white",
                              }}
                              onClick={() => {
                                setSupplier(null);
                                setSearchQuery("");
                              }}
                            >
                              Change
                            </Button>
                          </div>
                        )}
                        <div
                          style={
                            supplier
                              ? { display: "none" }
                              : { display: "block", width: "200px" }
                          }
                        >
                          <Autocomplete
                            {...suppliersProps}
                            // PaperComponent={CustomPaper}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                // required={!invoice && true}
                                label="Select Supplier"
                                margin="normal"
                                variant="outlined"
                                // error={touched && !!errors.client}
                                // helperText={touched && errors.client}
                              />
                            )}
                            value={supplier}
                            onChange={(event, value) => {
                              setSupplier(value);
                              setSearchQuery(value ? value._id : "");

                              // handleClientChange();
                            }}
                            // onChange={(event, value) => setClient(value) }
                          />
                        </div>
                      </Container>
                    </ThemeProvider>
                  ) : null}
                </div>
              )}
              {/* {user?.result?.userType !== "admin" && (
                <ThemeProvider theme={colorTheme}>
                  <Container>
                    {party && (
                      <div
                        style={{
                          display: "flex",
                          marginTop: "20px",
                          gap: "10px",
                          height: "50px",
                        }}
                      >
                        <Typography variant="subtitle1" gutterBottom>
                          {party.name}
                        </Typography>

                        <Button
                          color="primary"
                          size="small"
                          style={{
                            textTransform: "none",
                            backgroundColor: "#ef7f1a",
                            color: "white",
                          }}
                          onClick={() => {
                            setParty(null);
                            setSearchQuery("");
                          }}
                        >
                          Change
                        </Button>
                      </div>
                    )}
                    <div
                      style={
                        party
                          ? { display: "none" }
                          : { display: "block", width: "200px" }
                      }
                    >
                      <Autocomplete
                        {...clientsProps}
                        // PaperComponent={CustomPaper}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            // required={!invoice && true}
                            label="Select Party"
                            margin="normal"
                            variant="outlined"
                            // error={touched && !!errors.client}
                            // helperText={touched && errors.client}
                          />
                        )}
                        value={clients?.name}
                        onChange={(event, value) => {
                          setParty(value);
                          setSearchQuery(value ? value._id : "");

                          // handleClientChange();
                        }}
                        // onChange={(event, value) => setClient(value) }
                      />
                    </div>
                  </Container>
                </ThemeProvider>
              )} */}

              {loading ? (
                <CircularProgress
                  style={{ marginTop: "20px", marginLeft: "10px" }}
                />
              ) : (
                user?.result?.userType === "admin" && (
                  <Button
                    variant="outlined"
                    endIcon={<GetAppIcon />}
                    onClick={createAndDownloadPdf}
                    style={{
                      margin: "16px 0 8px 0",
                    }}
                  >
                    PDF
                  </Button>
                )
              )}
            </div>
            {hasActiveFilters && (
              <div
                className={classes.textContainer}
                style={{ margin: isMobile ? "0" : "10px 0 0 2rem" }}
              >
                <Typography variant="h6" className={classes.typography}>
                  Orders Count: {totalItems || numberOfPages || 0}
                </Typography>

                <Typography variant="h6" className={classes.typography}>
                  Total Orders MRP: ₹{toCommas(totalAmount || 0)}
                </Typography>
              </div>
            )}
          </div>
          {startDate && endDate && searchQuery && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "16px",
              }}
            >
              <Button
                variant="outlined"
                onClick={() => setShowNonOrderParties(!showNonOrderParties)}
                style={{
                  margin: "16px 0 8px 0",
                }}
              >
                {showNonOrderParties
                  ? "Hide Non-Order Parties"
                  : "Show Non-Order Parties"}
              </Button>
            </div>
          )}

          <Grid container spacing={2}>
            <Grid
              item
              xs={showNonOrderParties ? 12 : 12}
              md={showNonOrderParties ? 8 : 12}
            >
              <TableContainer component={Paper} elevation={0}>
                <Table
                  className={classes.table}
                  aria-label="custom pagination table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell style={headerStyle}>Order No</TableCell>

                      <TableCell style={headerStyle}>Date</TableCell>
                      {user?.result?.userType !== "dealer" && (
                        !supplier && <TableCell style={headerStyle}>Supplier</TableCell>
                      )}
                      {user?.result?.userType !== "dealer" && !party && (
                        <TableCell style={headerStyle}>Party</TableCell>
                      )}
                      <TableCell style={headerStyle}>Amount</TableCell>
                      {/* <TableCell style={headerStyle}>Due Date</TableCell> */}

                      {/* <TableCell style={headerStyle}>Status</TableCell> */}
                      {(user?.result?.userType === "admin" || user?.result?.userType === "dealer") &&
                        selectedFilter !== "salesperson" && (
                          <TableCell style={headerStyle}>
                            Created By
                          </TableCell>
                        )}
                      {/* <TableCell style={headerStyle}>View</TableCell> */}

                      {user?.result?.userType === "admin" &&
                        <TableCell style={headerStyle}>Edit</TableCell>
                      }

                      {user?.result?.userType === "admin" && (
                        <TableCell style={headerStyle}>Delete</TableCell>
                      )}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {filteredRows.length > 0 ? (
                      filteredRows.map((row) => (
                        <TableRow key={row._id} style={{ cursor: "pointer" }}>
                          <TableCell
                            style={tableStyle}
                            onClick={() => openInvoice(row._id)}
                          >
                            {" "}
                            {row.invoiceNumber}{" "}
                          </TableCell>
                          <TableCell
                            style={tableStyle}
                            onClick={() => openInvoice(row._id)}
                          >
                            {" "}
                            {formatLocalDateTime(row.createdAt)}{" "}
                          </TableCell>
                          {user?.result?.userType !== "dealer" && !supplier && (
                            <TableCell
                              style={tableStyle}
                              onClick={() => openInvoice(row._id)}
                            >
                              {row.supplier.name}{" "}
                            </TableCell>
                          )}
                          {user?.result?.userType !== "dealer" && !party && (
                            <TableCell
                              style={tableStyle}
                              onClick={() => {
                                user?.result?.userType === "admin" &&
                                  handleClientNameClick(row._id);
                              }}
                            >
                              {" "}
                              {row.client.name}{" "}
                            </TableCell>
                          )}
                          <TableCell
                            style={tableStyle}
                            onClick={() => openInvoice(row._id)}
                          >
                            {row.currency}{" "}
                            {row.total ? toCommas(row.total) : row.total}{" "}
                          </TableCell>
                          {/* <TableCell style={tableStyle} onClick={() => openInvoice(row._id)}>
                      {" "}
                      {moment(row.dueDate).fromNow()}{" "}
                    </TableCell> */}
                          {/* <TableCell
                      style={tableStyle}
                    >
                      {" "}
                      <button style={checkStatus(row.status)}>
                        {row.status}
                      </button>
                    </TableCell> */}
                          {(user?.result?.userType === "admin" || user?.result?.userType === "dealer") &&
                            selectedFilter !== "salesperson" && (
                              <TableCell
                                style={tableStyle}
                                onClick={() => openInvoice(row._id)}
                              >
                                {" "}
                                {getCreatorDisplay(row.creator)}{" "}
                              </TableCell>
                            )}
                          {/* <TableCell style={tableStyle}>
                      {" "}
                      <IconButton onClick={() => openInvoice(row._id)}>
                        <RemoveRedEyeOutlinedIcon
                          style={{ width: "20px", height: "20px" }}
                        />
                      </IconButton>
                    </TableCell> */}
{user?.result?.userType === "admin" &&
                          <TableCell style={{ ...tableStyle, width: "10px" }}>
                            <IconButton onClick={() => editInvoice(row._id)}>
                              <BorderColorIcon
                                style={{ width: "20px", height: "20px" }}
                              />
                            </IconButton>
                          </TableCell>
}

                          {user?.result?.userType === "admin" && (
                            <TableCell style={{ ...tableStyle, width: "10px" }}>
                              <IconButton onClick={() => handleDelete(row._id)}>
                                <DeleteOutlineRoundedIcon
                                  style={{ width: "20px", height: "20px" }}
                                />
                              </IconButton>
                            </TableCell>
                          )}
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell 
                          colSpan={user?.result?.userType === "admin" ? 7 : 5} 
                          style={{ 
                            textAlign: "center", 
                            padding: "40px", 
                            color: "gray",
                            fontSize: "16px"
                          }}
                        >
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <NoData />
                            <p style={{ marginTop: "20px", color: "gray" }}>
                              No results found
                            </p>
                            <p style={{ marginTop: "10px", color: "#666", fontSize: "14px" }}>
                              Try adjusting your search criteria or date range
                            </p>
                          </div>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                  {filteredRows.length > 0 && (
                    <TableFooter>
                      <TableRow>
                        <TablePagination
                          rowsPerPageOptions={[
                            5,
                            10,
                            25,
                            50,
                            100,
                            // { label: "All", value: numberOfPages },
                          ]}
                          colSpan={6}
                          count={numberOfPages ? numberOfPages : 25}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          SelectProps={{
                            inputProps: { "aria-label": "rows per page" },
                            native: true,
                          }}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          ActionsComponent={TablePaginationActions}
                        />
                      </TableRow>
                    </TableFooter>
                  )}
                </Table>
              </TableContainer>
            </Grid>
            {showNonOrderParties && (
              <Grid item xs={12} md={4}>
                <NonOrderPartiesTable
                  nonOrderParties={nonOrderParties}
                  nonOrderPartiesCount={nonOrderPartiesCount}
                  startDate={startDate}
                  endDate={endDate}
                  salesperson={salesperson}
                />
              </Grid>
            )}
          </Grid>
        </Container>
      </ThemeProvider>
    </div>
  );
};

export default Invoices;
